import React from 'react'

const scoreColor = {
  low: '#E53E3E',
  medium: '#ECC94B',
  high: '#48BB78',
}

export const ScoreMeter = ({ score, width = 285 }) => {
  const scoreSvg = {
    zero: (
      <svg
        width={width}
        height="auto"
        viewBox="0 0 285 137"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_8780_256435)">
          <path
            d="M16.3115 129.56C20.3417 95.9721 37.225 66.3215 61.8418 45.8387C65.0278 43.1957 65.7903 38.5706 63.5574 35.0466C60.9432 30.8895 55.3064 29.9259 51.5213 33.0369C23.6639 56.1627 4.57496 89.6951 0.054607 127.687C-0.517245 132.56 3.32233 136.8 8.16945 136.8H8.22392C12.363 136.8 15.7941 133.689 16.3115 129.532V129.56Z"
            fill="#CBD5E0"
          />
          <path
            d="M77.3065 26.0991C79.5395 29.623 84.0054 30.8894 87.736 29.0724C104.32 21.0334 122.891 16.5184 142.498 16.5184C162.104 16.5184 180.676 21.0334 197.259 29.0724C200.99 30.8894 205.483 29.623 207.689 26.0991C210.303 21.942 208.805 16.3808 204.421 14.2609C185.659 5.14824 164.664 0 142.498 0C120.332 0 99.3364 5.12071 80.5743 14.2609C76.1901 16.3808 74.6924 21.9695 77.3065 26.0991Z"
            fill="#CBD5E0"
          />
          <path
            d="M221.473 35.0195C219.267 38.5434 220.002 43.1686 223.188 45.8115C247.805 66.2943 264.689 95.9449 268.719 129.532C269.209 133.662 272.667 136.8 276.806 136.8H276.861C281.708 136.8 285.548 132.533 284.976 127.688C280.455 89.6954 261.366 56.1631 233.509 33.0097C229.751 29.8712 224.087 30.8624 221.473 35.0195Z"
            fill="#CBD5E0"
          />
        </g>
        <defs>
          <clipPath id="clip0_8780_256435">
            <rect width="285" height="136.8" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    low: (
      <svg
        width={width}
        height="auto"
        viewBox="0 0 285 137"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_8780_256435)">
          <path
            d="M16.3115 129.56C20.3417 95.9721 37.225 66.3215 61.8418 45.8387C65.0278 43.1957 65.7903 38.5706 63.5574 35.0466C60.9432 30.8895 55.3064 29.9259 51.5213 33.0369C23.6639 56.1627 4.57496 89.6951 0.054607 127.687C-0.517245 132.56 3.32233 136.8 8.16945 136.8H8.22392C12.363 136.8 15.7941 133.689 16.3115 129.532V129.56Z"
            fill="currentColor"
          />
          <path
            d="M77.3065 26.0991C79.5395 29.623 84.0054 30.8894 87.736 29.0724C104.32 21.0334 122.891 16.5184 142.498 16.5184C162.104 16.5184 180.676 21.0334 197.259 29.0724C200.99 30.8894 205.483 29.623 207.689 26.0991C210.303 21.942 208.805 16.3808 204.421 14.2609C185.659 5.14824 164.664 0 142.498 0C120.332 0 99.3364 5.12071 80.5743 14.2609C76.1901 16.3808 74.6924 21.9695 77.3065 26.0991Z"
            fill="#CBD5E0"
          />
          <path
            d="M221.473 35.0195C219.267 38.5434 220.002 43.1686 223.188 45.8115C247.805 66.2943 264.689 95.9449 268.719 129.532C269.209 133.662 272.667 136.8 276.806 136.8H276.861C281.708 136.8 285.548 132.533 284.976 127.688C280.455 89.6954 261.366 56.1631 233.509 33.0097C229.751 29.8712 224.087 30.8624 221.473 35.0195Z"
            fill="#CBD5E0"
          />
        </g>
        <defs>
          <clipPath id="clip0_8780_256435">
            <rect width="285" height="136.8" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    medium: (
      <svg
        width={width}
        height="auto"
        viewBox="0 0 285 137"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_8780_256435)">
          <path
            d="M16.3115 129.56C20.3417 95.9721 37.225 66.3215 61.8418 45.8387C65.0278 43.1957 65.7903 38.5706 63.5574 35.0466C60.9432 30.8895 55.3064 29.9259 51.5213 33.0369C23.6639 56.1627 4.57496 89.6951 0.054607 127.687C-0.517245 132.56 3.32233 136.8 8.16945 136.8H8.22392C12.363 136.8 15.7941 133.689 16.3115 129.532V129.56Z"
            fill="currentColor"
          />
          <path
            d="M77.3065 26.0991C79.5395 29.623 84.0054 30.8894 87.736 29.0724C104.32 21.0334 122.891 16.5184 142.498 16.5184C162.104 16.5184 180.676 21.0334 197.259 29.0724C200.99 30.8894 205.483 29.623 207.689 26.0991C210.303 21.942 208.805 16.3808 204.421 14.2609C185.659 5.14824 164.664 0 142.498 0C120.332 0 99.3364 5.12071 80.5743 14.2609C76.1901 16.3808 74.6924 21.9695 77.3065 26.0991Z"
            fill="currentColor"
          />
          <path
            d="M221.473 35.0195C219.267 38.5434 220.002 43.1686 223.188 45.8115C247.805 66.2943 264.689 95.9449 268.719 129.532C269.209 133.662 272.667 136.8 276.806 136.8H276.861C281.708 136.8 285.548 132.533 284.976 127.688C280.455 89.6954 261.366 56.1631 233.509 33.0097C229.751 29.8712 224.087 30.8624 221.473 35.0195Z"
            fill="#CBD5E0"
          />
        </g>
        <defs>
          <clipPath id="clip0_8780_256435">
            <rect width="285" height="136.8" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    high: (
      <svg
        width={width}
        height="auto"
        viewBox="0 0 285 137"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_8780_256435)">
          <path
            d="M16.3115 129.56C20.3417 95.9721 37.225 66.3215 61.8418 45.8387C65.0278 43.1957 65.7903 38.5706 63.5574 35.0466C60.9432 30.8895 55.3064 29.9259 51.5213 33.0369C23.6639 56.1627 4.57496 89.6951 0.054607 127.687C-0.517245 132.56 3.32233 136.8 8.16945 136.8H8.22392C12.363 136.8 15.7941 133.689 16.3115 129.532V129.56Z"
            fill="currentColor"
          />
          <path
            d="M77.3065 26.0991C79.5395 29.623 84.0054 30.8894 87.736 29.0724C104.32 21.0334 122.891 16.5184 142.498 16.5184C162.104 16.5184 180.676 21.0334 197.259 29.0724C200.99 30.8894 205.483 29.623 207.689 26.0991C210.303 21.942 208.805 16.3808 204.421 14.2609C185.659 5.14824 164.664 0 142.498 0C120.332 0 99.3364 5.12071 80.5743 14.2609C76.1901 16.3808 74.6924 21.9695 77.3065 26.0991Z"
            fill="currentColor"
          />
          <path
            d="M221.473 35.0195C219.267 38.5434 220.002 43.1686 223.188 45.8115C247.805 66.2943 264.689 95.9449 268.719 129.532C269.209 133.662 272.667 136.8 276.806 136.8H276.861C281.708 136.8 285.548 132.533 284.976 127.688C280.455 89.6954 261.366 56.1631 233.509 33.0097C229.751 29.8712 224.087 30.8624 221.473 35.0195Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0_8780_256435">
            <rect width="285" height="136.8" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
  }

  const scoreType =
    score === 0 ? 'zero' : score < 40 ? 'low' : score < 80 ? 'medium' : 'high'
  const color = scoreColor[scoreType]
  const ScoreElem = scoreSvg[scoreType]

  return <div style={{ color: color }}>{ScoreElem}</div>
}
